'use client'

import React, { createContext, useState, useContext, useEffect } from 'react'
import { useAuth } from './AuthContext'
import { api } from '../configs/api'

type ProductDataType = {
    id: string
    name: string
    image?: string
}

type ProductType = {
    products: ProductDataType[]
    setProducts: (value: ProductDataType[]) => void
    filteredProducts: ProductDataType[]
    setFilteredProducts: (value: ProductDataType[]) => void
}

const Product = createContext<ProductType | undefined>(undefined)

export const ProductProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { unity } = useAuth()
    const [products, setProducts] = useState<ProductDataType[]>([])
    const [filteredProducts, setFilteredProducts] = useState<ProductDataType[]>([])

    const loadProducts = async () => {
        if (!unity) return

        const response = await fetch(`${api}product/getData`, {
            method: 'POST',
            body: JSON.stringify({
                unityID: unity.unityID
            })
        })
        const result = await response.json()

        setProducts(result.products)
        setFilteredProducts(result.products)
    }

    useEffect(() => {
        //* Carrega produtos
        loadProducts()
    }, [unity])

    return (
        <Product.Provider
            value={{
                products,
                setProducts,
                filteredProducts,
                setFilteredProducts
            }}
        >
            {children}
        </Product.Provider>
    )
}

export function useProduct() {
    const context = useContext(Product)
    if (context === undefined) {
        throw new Error('useCreate must be used within a ProductProvider')
    }
    return context
}
